export default "__VITE_ASSET__xIllrZ0M__"